import script from "./BasicInfoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfoForm.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfoForm.vue?vue&type=style&index=0&id=12822ab9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12822ab9"]])

export default __exports__